<template>
	<div class="text">
		<p>1. 本平台提供红包提现功能，提现方式为提现到认证用户账号下的银行卡。</p>
		<p>2. 提现时设有最新提现金额，最低提现金额是实际页面展示为准。基于用户账号及安全考虑，提现一般3~5天内到账(您理解并同意如遇提现高峰，提现到账时间会延长)。提现申请需要审核，审核预计时间为24小时。若遇问题，请联系客服处理。</p>
		<p>3. 为保证用户顺利提现以及账号安全，提现前需用户进行身份实名认证；完成用户本人实名认证后可进行提现操作。如用户未按提现要求操作或不符合第三方支付平台的要求等原因导致不能收款(如未完成实名认证)，所获得的红包将无法提现，本平台无需承担任何责任。</p>
		<p>4. 未成年人用户应在其监护人的陪同下使用本APP并应在征得其监护人的同意后进行，用户均应确保提供的信息准确无误，如因填写信息错误等非本平台原因导致不能提现，视为用户自愿放弃全部金额，平台不承担责任。</p>
		<p>5. 请不要泄露你的账户密码，因此造成的损失，平台概不负责。</p>
		<p>6. 我们应用先进的人工智能分析您的行为，在提现过程中，为更好的保护用户账号及相关资产的安全，本平台有权对您的提现的次数、金额和/或账号的数量进行限数、金额和/或账号的数量进行限制，并随时提高安全校验措施(包括但不限于短信验证、身份验证等手段)，如用户未能通过安全校验的则将无法提现/兑换，如发现造假或其他不正当手段及舞弊行为，我们有权阻止您使用(填写邀请码、获得奖励、提现奖励)以及取消您获得的奖励。用户应自行承担因此不能提现/兑换所导致的不利后果，本平台对此不承担责任。按照相关法律规定，主办方需就用户在平台所得，主办方有权依法代扣代缴，主办方会代用户报税，低于8万以内的收入，税费平台会代用户缴纳，超过8万部分的税费需用户自己缴纳，用户获得红包金额为税后金额。</p>
		<p>7、本平台的账户奖励金（以下统称“余额”），包括但不限于奖励金、红包等，若用户30天内未及时领取，则视为用户自动放弃账户相关余额，平台采取回收账户余额措施，从而导致的一切责任，概由用户自行负责，与公司和平台无任何关联，用户日后不得以任何理由向公司或平台提出任何关于回收账户余额的相关抗辩、控告、仲裁或诉讼。
</p>
	</div>
</template>

<script>
	export default {
		beforeCreate() {
			document.title = '提现说明'
		}
	}
</script>

<style>
	.text {
		padding: 15px;
		font-size: 14px;
		color: #333;
	}

	.text p {
		line-height: 1.6;
	}

	.text .head {
		font-weight: 500;
	}

	.text .space2 {
		text-indent: 2em;
	}

	.text .space4 {
		text-indent: 4em;
	}
</style>
